import api from './api'

export const fetchPendingAssignments = () =>
	api.get('/counseling/dashboard/assignments-pending')

export const markAssignmentSeen = (assignmentId, { anchorAt } = {}) =>
	api.post(
		`/counseling/dashboard/assignments/${encodeURIComponent(assignmentId)}/seen`,
		{ anchor_at: anchorAt || undefined },
	)
